'use client';

import { useEffect } from 'react';

/**
 * The root layout renders `<html lang="en">`; a nested route can't change that
 * attribute server-side, so sync it to the active hub locale on the client
 * (mirrors what the comp does). Restores `en` on unmount so leaving the hub
 * doesn't strand the document in `es`.
 */
export default function HtmlLang({ locale }: { locale: Locale }) {
  useEffect(() => {
    const previous = document.documentElement.lang;
    document.documentElement.lang = locale;
    return () => {
      document.documentElement.lang = previous || 'en';
    };
  }, [locale]);

  return null;
}
